import { TLoginRequest } from "@/features/auth/types/loginRequest";
import { TLoginResponse } from "@/features/auth/types/loginResponse";
import { clientApi } from "@/utils/api";
import { TApiRes } from "@/types/api";

export const loginApi = async (payload: TLoginRequest): Promise<TLoginResponse> => {
  const {
    data: { data },
  } = await clientApi.post<TApiRes<TLoginResponse>>("/login", payload);
  return data;
};
